module.exports = __webpack_public_path__ + "img/coya.a2812495.jpg";